import React from 'react';
import { Helmet } from 'react-helmet-async';
import CampaignChatUI from '@/components/campaign/CampaignChatUI';
import { Shield, Heart, DollarSign } from 'lucide-react';

const CancerCareCampaign: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Cancer Care Cover — Get an Indicative Quote | OneStop Financial Solutions</title>
        <meta name="description" content="Find out about AIA Cancer Care cover. Get indicative pricing and speak with an adviser. Specialised health insurance for cancer diagnosis, treatment, and recovery." />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-br from-background via-background to-muted/30">
        <div className="max-w-6xl mx-auto px-4 py-8 md:py-12">
          <div className="grid md:grid-cols-5 gap-8 items-start">
            {/* Left panel — info */}
            <div className="md:col-span-2 space-y-6">
              <div>
                <p className="text-sm font-medium text-brand-teal uppercase tracking-wider mb-2">OneStop Financial Solutions</p>
                <h1 className="text-3xl md:text-4xl font-bold text-foreground leading-tight">
                  Cancer Care Cover
                </h1>
                <p className="text-muted-foreground mt-3 text-base leading-relaxed">
                  Specialised health insurance for cancer diagnosis, treatment, and recovery. 
                  Get an indicative quote in minutes.
                </p>
              </div>

              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-brand-teal/10 flex items-center justify-center shrink-0">
                    <Shield className="h-5 w-5 text-brand-teal" />
                  </div>
                  <div>
                    <h3 className="font-medium text-foreground text-sm">Up to $500,000 cover</h3>
                    <p className="text-xs text-muted-foreground">Diagnosis, treatment, and recovery</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-brand-teal/10 flex items-center justify-center shrink-0">
                    <Heart className="h-5 w-5 text-brand-teal" />
                  </div>
                  <div>
                    <h3 className="font-medium text-foreground text-sm">Unlimited surgery benefit</h3>
                    <p className="text-xs text-muted-foreground">Surgeon, anaesthetist, hospital fees</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-brand-teal/10 flex items-center justify-center shrink-0">
                    <DollarSign className="h-5 w-5 text-brand-teal" />
                  </div>
                  <div>
                    <h3 className="font-medium text-foreground text-sm">From ~$11/week</h3>
                    <p className="text-xs text-muted-foreground">Indicative pricing — get your estimate now</p>
                  </div>
                </div>
              </div>

              <div className="bg-muted/50 rounded-lg p-4">
                <p className="text-xs text-muted-foreground leading-relaxed">
                  The information provided is general in nature and not intended as personalised advice. 
                  Availability of cover is subject to application approval. AIA Cancer Care is underwritten 
                  by AIA New Zealand Limited.
                </p>
              </div>
            </div>

            {/* Right panel — chat */}
            <div className="md:col-span-3 h-[600px] md:h-[700px]">
              <CampaignChatUI
                campaignSlug="cancer_care"
                sourceChannel="web_landing"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CancerCareCampaign;
